import { TRuleWithTheme } from 'styles/theme';

export const group: TRuleWithTheme = ({ theme }) => ({
    '&:not(:last-child)': {
        marginBottom: '1.5rem',
        borderBottom: `1px solid ${theme.colors.dividerColor}`,
    },
});
